var exports = {
  "kL": "x805b157e--700b7a--container",
  "kb": "x805b157e--700b7a--left",
  "gX": "x805b157e--700b7a--center",
  "pG": "x805b157e--700b7a--right",
};

module.exports = exports;
